export const TASK_STATUS_META = {
  completed: { label: '已完成', className: 'is-completed' },
  pending: { label: '排队中', className: 'is-processing' },
  processing: { label: '处理中', className: 'is-processing' },
  failed: { label: '失败', className: 'is-failed' },
  webhook_error: { label: '失败', className: 'is-failed' }
};

export const normalizeTaskValue = (value) => {
  if (!value || typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch (_) {
    return value;
  }
};

const collectTaskUrls = (value, urls = [], visited = new WeakSet()) => {
  if (!value) return urls;
  if (typeof value === 'string') {
    if (/^https?:\/\//i.test(value)) urls.push(value);
    return urls;
  }
  if (typeof value !== 'object' || visited.has(value)) return urls;
  visited.add(value);
  if (Array.isArray(value)) {
    value.forEach((item) => collectTaskUrls(item, urls, visited));
  } else {
    Object.values(value).forEach((item) => collectTaskUrls(item, urls, visited));
  }
  return urls;
};

const classifyTaskUrl = (url) => {
  const value = String(url || '').toLowerCase();
  if (/\.(mp4|webm|mov)(\?|$)/.test(value) || value.includes('/video/')) return 'video';
  if (/\.(mp3|wav|ogg|aac|m4a)(\?|$)/.test(value) || value.includes('/audio/')) return 'audio';
  if (/\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/.test(value) || value.includes('/image/')) return 'image';
  return 'unknown';
};

export const getTaskPreview = (task) => {
  const output = normalizeTaskValue(task?.output_params);
  if (!output || typeof output !== 'object') return null;

  const directImage = output.image_url
    || (typeof output.image === 'string' ? output.image : output.image?.url)
    || (Array.isArray(output.images)
      ? (typeof output.images[0] === 'string' ? output.images[0] : output.images[0]?.url)
      : null);
  if (directImage) return { type: 'image', url: directImage };

  const directVideo = output.video_url || output.video?.url;
  if (directVideo) return { type: 'video', url: directVideo };

  const directAudio = output.audio_url || output.audio?.url;
  if (directAudio) return { type: 'audio', url: directAudio };

  const urls = [...new Set(collectTaskUrls(output))];
  for (const type of ['image', 'video', 'audio']) {
    const url = urls.find((item) => classifyTaskUrl(item) === type);
    if (url) return { type, url };
  }
  return null;
};

export const getTaskModelName = (appName) => {
  const parts = String(appName || '未知模型').split('/').filter(Boolean);
  return parts[parts.length - 1] || '未知模型';
};

export const getTaskStatusMeta = (status) => (
  TASK_STATUS_META[status] || TASK_STATUS_META.processing
);

export const getTaskPrompt = (task) => {
  const input = normalizeTaskValue(task?.input_params);
  const output = normalizeTaskValue(task?.output_params);
  return input?.prompt || output?.prompt || '';
};

export const formatTaskTime = (value, includeYear = false) => {
  if (!value) return '时间未知';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '时间未知';
  return date.toLocaleDateString('zh-CN', {
    ...(includeYear ? { year: 'numeric' } : {}),
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

export const formatTaskPoints = (value) => {
  const points = Number(value);
  if (!Number.isFinite(points)) return '0';
  return points.toLocaleString('zh-CN', { maximumFractionDigits: 4 });
};
